import { render } from "./PlaceholderImageSelector.vue?vue&type=template&id=10c3cb7c"
import script from "./PlaceholderImageSelector.vue?vue&type=script&lang=js"
export * from "./PlaceholderImageSelector.vue?vue&type=script&lang=js"

import "./PlaceholderImageSelector.vue?vue&type=style&index=0&id=10c3cb7c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__